import React, { Component } from 'react';
import * as Http from '../../http'
import * as Business from '../../utils/business'
import Loading from '../../components/Loading'
import { MenuItem, DropdownButton } from 'react-bootstrap';

const dicAssetClass = {
  'asset_class_1': 'Khoản phải đòi doanh nghiệp, quốc gia, ngân hàng',
  'asset_class_2': 'Khoản phải đòi chuyên biệt',
  'asset_class_3': 'Khoản cho vay thế chấp nhà',
  'asset_class_4': 'Khoản tín dụng bán lẻ quay vòng tiêu chuẩn',
  'asset_class_5': 'Các khoản tín dụng bán lẻ còn lại',
}

const defaultData = {
  'asset_class_1': { correlation: "(R)=0.12×(1− e^((−50×PD)))/(1−e^((−50)) )+0.24×(1−(1− e^((−50×PD)))/(1−e^((−50)) ))", maturity_adjustment: '(b)=(0.11852−0.05478×ln⁡(PD) )^2', capital_requirement: '(K)= [LGD×N[(1/(1−R))^0.5×G(PD)+ (R/(1−R))^0.5×G(0.999)]−PD×LGD]×1/(1−1.5∗b)×(1+(𝑀−2.5)×b) ', risk_weighted_assets: '(RWA)=K×12.5×EAD' },
  'asset_class_2': { correlation: '(R)=0.12×(1− e^((−50×PD)))/(1−e^((−50)) )+0.30×(1−(1− e^((−50×PD)))/(1−e^((−50)) ))', maturity_adjustment: '(b)=(0.11852−0.05478×ln⁡(PD) )^2', capital_requirement: '(K)= [LGD×N[(1/(1−R))^0.5×G(PD)+ (R/(1−R))^0.5×G(0.999)]−PD×LGD]×1/(1−1.5∗b)×(1+(𝑀−2.5)×b) ', risk_weighted_assets: '(RWA)=K×12.5×EAD' },
  'asset_class_3': { correlation: '(R) = 0.15', maturity_adjustment: '', capital_requirement: '(K)= LGD×N[(1/(1−R))^0.5×G(PD)+ (R/(1−R))^0.5×G(0.999)]−PD×LGD', risk_weighted_assets: '(RWA)=K×12.5×EAD' },
  'asset_class_4': { correlation: '(R) = 0.04', maturity_adjustment: '', capital_requirement: '(K)= LGD×N[(1/(1−R))^0.5×G(PD)+ (R/(1−R))^0.5×G(0.999)]−PD×LGD', risk_weighted_assets: '(RWA)=K×12.5×EAD' },
  'asset_class_5': { correlation: '(R)=0.03×(1− e^((−35×PD)))/(1−e^((−35)) )+0.16×(1−(1− e^((−35×PD)))/(1−e^((−35)) ))', maturity_adjustment: '', capital_requirement: '(K)= LGD×N[(1/(1−R))^0.5×G(PD)+ (R/(1−R))^0.5×G(0.999)]−PD×LGD', risk_weighted_assets: '(RWA)=K×12.5×EAD' },
};

export default class ConfigAssetClass extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      data: defaultData,
      assetClass: 'asset_class_1',
      showDeleteAlert: false
    }
    this.usernameWillDelete = null
  }

  componentDidMount() {
    // do something
  }

  onUpdateData = () => {
    this.setState({
      loading: true
    }, () => {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 500)
    })
  }

  renderRow = () => {
    const currentAssetClass = this.state.assetClass;
    const assetClassValue = this.state.data && this.state.data[currentAssetClass] ? this.state.data[currentAssetClass] : {};
    return (
      <table className="table table-hover table-striped">
        <thead>
          <tr>
            <th>Asset Class</th>
            <th>Correlation</th>
            <th>Maturity Adjustment</th>
            <th>Capital Requirement</th>
            <th>Risk-weighted Assets</th>
          </tr>
        </thead>
        <tbody>
          <tr key={this.state.assetClass}>
            <td style={{ width: '400px' }}>{dicAssetClass[currentAssetClass]}</td>
            <td>
              <input type="text" value={assetClassValue.correlation} onChange={(event) => {
                const data = JSON.parse(JSON.stringify(this.state.data));
                const row = data[currentAssetClass];
                row.correlation = event.target.value;
                data[currentAssetClass] = row
                this.setState({ data })
              }} />
            </td>
            <td>
              <input type="text" value={assetClassValue.maturity_adjustment} onChange={(event) => {
                const data = JSON.parse(JSON.stringify(this.state.data));
                const row = data[currentAssetClass];
                row.maturity_adjustment = event.target.value;
                data[currentAssetClass] = row
                this.setState({ data })
              }} />
            </td>
            <td>
              <input type="text" value={assetClassValue.capital_requirement} onChange={(event) => {
                const data = JSON.parse(JSON.stringify(this.state.data));
                const row = data[currentAssetClass];
                row.capital_requirement = event.target.value;
                data[currentAssetClass] = row
                this.setState({ data })
              }} />
            </td>
            <td>
              <input type="text" value={assetClassValue.risk_weighted_assets} onChange={(event) => {
                const data = JSON.parse(JSON.stringify(this.state.data));
                const row = data[currentAssetClass];
                row.risk_weighted_assets = event.target.value;
                data[currentAssetClass] = row
                this.setState({ data })
              }} />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  handleSelectAssetClass = (eventKey, event) => {
    const data = JSON.parse(JSON.stringify(this.state.data));
    this.setState({ assetClass: eventKey });
  }

  render() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    return (
      <div className="card">
        <div className="header">
          <h4 className="title">Asset Class</h4>
          <div>
            <div style={{ display: 'inline' }}>
              <DropdownButton
                title={dicAssetClass[this.state.assetClass]}
                bsSize="small"
                id={`dropdown-size-${1}`}
              >
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetClass(eventKey, event); }} eventKey="asset_class_1">{dicAssetClass['asset_class_1']}</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetClass(eventKey, event); }} eventKey="asset_class_2">{dicAssetClass['asset_class_2']}</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetClass(eventKey, event); }} eventKey="asset_class_3">{dicAssetClass['asset_class_3']}</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetClass(eventKey, event); }} eventKey="asset_class_4">{dicAssetClass['asset_class_4']}</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetClass(eventKey, event); }} eventKey="asset_class_5">{dicAssetClass['asset_class_5']}</MenuItem>
                <MenuItem divider />
              </DropdownButton>
            </div>
            <button type="button" style={{ display: 'inline', float: 'right' }} className="btn btn-primary" onClick={() => {
              this.onUpdateData();
            }}>Update</button>
          </div>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          {this.renderRow()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Config/ConfigAssetClass.js